<template>
  <div class="data-null">
		<van-image width="170px" height="auto" fit="fill" :src="noDataImg" />
		<div class="title">您还没有相关的线索</div>
		<div class="title1">快去推荐更多人来参与活动吧~</div>
		<van-button class="button" plain  round color="#FF6B31" @click="to">返回</van-button>
	</div>
</template>

<script>
import noDataImg from '@/assets/images/img-default@2x.png'
export default {
	data() {
		return {
			noDataImg: noDataImg,
		}
	},
	methods: {
		to() {
			this.$router.go(-1)
		}
	}
}
</script>

<style lang="stylus" scoped>
	.data-null {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		height: 100vh;
		.title {
			font-size: 18px;
			margin-top: 20px;
			font-weight: 600;
		}
		.title1 {
			margin-top: 10px;
			color: #999999;
		}
		.button {
			margin-top: 120px;
			width: 200px;
			background: none;
		}
	}
</style>